import { CalculateIcon, IconButton, useModal } from '@bami-libs/uikit'
import BigNumber from 'bignumber.js'
import { Address } from 'config/constants/types'
import React from 'react'
import ApyCalculatorModal from './ApyCalculatorModal'

export interface ApyButtonProps {
  lpLabel?: string
  cakePrice?: BigNumber
  apy?: BigNumber
  quoteTokenAdresses?: Address
  quoteTokenSymbol?: string
  tokenAddresses: Address
  isTokenOnly?: boolean
  rewardToken: string
}

const ApyButton: React.FC<ApyButtonProps> = ({
  lpLabel,
  quoteTokenAdresses,
  quoteTokenSymbol,
  tokenAddresses,
  cakePrice,
  apy,
  isTokenOnly,
  rewardToken,
}) => {
  const [onPresentApyModal] = useModal(
    <ApyCalculatorModal
      rewardToken={rewardToken}
      lpLabel={lpLabel}
      quoteTokenAdresses={quoteTokenAdresses}
      quoteTokenSymbol={quoteTokenSymbol}
      tokenAddresses={tokenAddresses}
      cakePrice={cakePrice}
      apy={apy}
      isTokenOnly={isTokenOnly}
    />,
  )

  return (
    <IconButton onClick={onPresentApyModal} color="#FF8C42" variant="text" size="sm" ml="4px">
      <CalculateIcon color="#FF8C42" />
    </IconButton>
  )
}

export default ApyButton
